import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from '@ibk/shared-translation';
import styles from '../BenefitCards.module.css';
import { BenefitCardHeader } from './BenefitCardHeader';
export const ActiveBenefitCard = ({ card, expanded }) => {
    const { id, title, iconName, creditRelease, beneficiaries, value, discount, onConfigure } = card;
    const { t } = useTranslation();
    const infoItems = [
        {
            label: t('benefit-card.credit-release'),
            value: creditRelease,
        },
        {
            label: t('benefit-card.beneficiaries'),
            value: beneficiaries,
        },
        {
            label: t('benefit-card.value'),
            value: value,
        },
        {
            label: t('benefit-card.discount'),
            value: discount,
        },
    ];
    const cardClasses = [styles.card, styles.cardActive, expanded && styles.cardExpanded].filter(Boolean).join(' ');
    return (_jsxs("div", { className: cardClasses, "data-testid": `active-card-${id}`, "data-expanded": expanded, children: [_jsx(BenefitCardHeader, { id: id, title: title, iconName: iconName, isActive: true, onConfigure: onConfigure }), _jsx("div", { className: styles.activeCardInfo, children: infoItems.map(item => (_jsxs("div", { className: styles.activeCardData, children: [_jsx("span", { className: styles.activeLabel, children: item.label }), _jsx("span", { className: styles.activeValue, children: item.value })] }, item.label))) })] }));
};
